import Error from './Error.vue';
import SelectCheck from './selectCheck.vue';
import StartPage from './StartPage.vue';
import Reviews from './Reviews.vue';
import Terms from './Terms.vue';

export const navigator = {
    ERROR : "ERROR",
    START_PAGE : "START_PAGE",
    ORDERS : "ORDERS",
    REVIEWS:"REVIEWS",
    TERMS:"TERMS"
}


export const routes_components = [
    { name: navigator.ERROR, component: Error },
    { name: navigator.ORDERS, component: SelectCheck },
    { name: navigator.START_PAGE, component: StartPage },
    { name: navigator.REVIEWS, component: Reviews },
    { name: navigator.TERMS, component: Terms }
];
